import { useTranslation } from 'react-i18next';
import { useLocation, useNavigate } from 'react-router';

import { LoginForm } from '@/features/auth';

import styles from '@/pages/auth.module.css';

export function LoginPage() {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const location = useLocation();
  const from = (location.state as { from?: string } | null)?.from ?? '/app';
  return (
    <section className={styles.page}>
      <h1 className={styles.title}>{t('auth.signInTitle')}</h1>
      <LoginForm onSuccess={() => void navigate(from, { replace: true })} />
    </section>
  );
}
